// extracted by mini-css-extract-plugin
export default {"select":"MultipleSelect_select__LHTn6","small":"MultipleSelect_small__wRtow","middle":"MultipleSelect_middle__GfXjN","large":"MultipleSelect_large__BK9Uh"};